export default __webpack_public_path__ + "static/mayfield-85e113fb3e35e3bd74b0c7c4a7055800.jpg";